// extracted by mini-css-extract-plugin
module.exports = {"person":"Person_person__1YPfy","person-credits":"Person_person-credits__3VC6S","loading":"Person_loading__1NxBb","error":"Person_error__1O4jQ"};